module.exports = __webpack_public_path__ + "img/shades-in-shadow.eec39baa.png";